import "core-js/modules/es6.reflect.construct.js";
import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.object.get-own-property-descriptor.js";
import "core-js/modules/es7.object.get-own-property-descriptors.js";
import _extends from "@babel/runtime/helpers/extends";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import "core-js/modules/es6.array.sort.js";
import "core-js/modules/es6.array.slice.js";
import "core-js/modules/es6.array.find-index.js";
import "core-js/modules/es6.array.map.js";
import "core-js/modules/es6.string.includes.js";
import "core-js/modules/es7.array.includes.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import classnames from 'classnames';
import { polyfill } from 'react-lifecycles-compat';
import KeyCode from 'rc-util/lib/KeyCode';
import CalendarPart from './range-calendar/CalendarPart';
import TodayButton from './calendar/TodayButton';
import OkButton from './calendar/OkButton';
import TimePickerButton from './calendar/TimePickerButton';
import { commonMixinWrapper, propType, defaultProp } from './mixin/CommonMixin';
import { syncTime, getTodayTime, isAllowedDate, formatDate } from './util';
import { goTime, goStartMonth, goEndMonth, includesTime } from './util/toTime';

function noop() {}

function isEmptyArray(arr) {
  return Array.isArray(arr) && (arr.length === 0 || arr.every(function (i) {
    return !i;
  }));
}

function isArraysEqual(a, b) {
  if (a === b) return true;

  if (a === null || typeof a === 'undefined' || b === null || typeof b === 'undefined') {
    return false;
  }

  if (a.length !== b.length) return false;

  for (var i = 0; i < a.length; ++i) {
    if (a[i] !== b[i]) return false;
  }

  return true;
}

function getValueFromSelectedValue(selectedValue) {
  var _selectedValue = _slicedToArray(selectedValue, 2),
      start = _selectedValue[0],
      end = _selectedValue[1];

  var newEnd = end && end.isSame(start, 'month') ? end.clone().add(1, 'month') : end;
  return [start, newEnd];
}

function normalizeAnchor(props, init) {
  var selectedValue = props.selectedValue || init && props.defaultSelectedValue;
  var value = props.value || init && props.defaultValue;
  var normalizedValue = value ? getValueFromSelectedValue(value) : getValueFromSelectedValue(selectedValue);
  return !isEmptyArray(normalizedValue) ? normalizedValue : init && [moment(), moment().add(1, 'months')];
}

function generateOptions(length, extraOptionGen) {
  var arr = extraOptionGen ? extraOptionGen().concat() : [];

  for (var value = 0; value < length; value++) {
    if (arr.indexOf(value) === -1) {
      arr.push(value);
    }
  }

  return arr;
}

function onInputSelect(direction, value, cause) {
  if (!value) {
    return;
  }

  var originalValue = this.state.selectedValue;
  var selectedValue = originalValue.concat();
  var index = direction === 'left' ? 0 : 1;
  selectedValue[index] = value;

  if (selectedValue[0] && this.compare(selectedValue[0], selectedValue[1]) > 0) {
    selectedValue[1] = this.state.showTimePicker ? selectedValue[index] : undefined;
  }

  if (selectedValue[0] && !selectedValue[1]) {
    selectedValue[1 - index] = this.state.showTimePicker ? selectedValue[index] : undefined;
  }

  this.props.onInputSelect(selectedValue);
  this.fireSelectValueChange(selectedValue, null, cause || {
    source: 'dateInput'
  });
}

var RangeCalendar = /*#__PURE__*/function (_React$Component) {
  _inherits(RangeCalendar, _React$Component);

  var _super = _createSuper(RangeCalendar);

  function RangeCalendar(_props) {
    var _this;

    _classCallCheck(this, RangeCalendar);

    _this = _super.call(this, _props);

    _defineProperty(_assertThisInitialized(_this), "onDatePanelEnter", function () {
      if (_this.hasSelectedValue()) {
        _this.fireHoverValueChange(_this.state.selectedValue.concat());
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onDatePanelLeave", function () {
      if (_this.hasSelectedValue()) {
        _this.fireHoverValueChange([]);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onMonthSelect", function (value) {
      _this.onSelect(value);
    });

    _defineProperty(_assertThisInitialized(_this), "onYearSelect", function (value) {
      _this.onSelect(value);
    });

    _defineProperty(_assertThisInitialized(_this), "onSelect", function (value) {
      var type = _this.props.type;
      var _this$state = _this.state,
          selectedValue = _this$state.selectedValue,
          prevSelectedValue = _this$state.prevSelectedValue,
          firstSelectedValue = _this$state.firstSelectedValue;
      var nextSelectedValue;

      if (type === 'both') {
        if (!firstSelectedValue) {
          syncTime(prevSelectedValue[0], value);
          nextSelectedValue = [value];
        } else if (_this.compare(firstSelectedValue, value) < 0) {
          syncTime(prevSelectedValue[1], value);
          nextSelectedValue = [firstSelectedValue, value];
        } else {
          syncTime(prevSelectedValue[0], value);
          syncTime(prevSelectedValue[1], firstSelectedValue);
          nextSelectedValue = [value, firstSelectedValue];
        }
      } else if (type === 'start') {
        syncTime(prevSelectedValue[0], value);
        var endValue = selectedValue[1];
        nextSelectedValue = endValue && _this.compare(endValue, value) > 0 ? [value, endValue] : [value];
      } else {
        // type === 'end'
        var startValue = selectedValue[0];

        if (startValue && _this.compare(startValue, value) <= 0) {
          syncTime(prevSelectedValue[1], value);
          nextSelectedValue = [startValue, value];
        } else {
          syncTime(prevSelectedValue[0], value);
          nextSelectedValue = [value];
        }
      }

      _this.fireSelectValueChange(nextSelectedValue);
    });

    _defineProperty(_assertThisInitialized(_this), "onKeyDown", function (event) {
      if (event.target.nodeName.toLowerCase() === 'input') {
        return;
      }

      var keyCode = event.keyCode;
      var ctrlKey = event.ctrlKey || event.metaKey;
      var _this$state2 = _this.state,
          selectedValue = _this$state2.selectedValue,
          hoverValue = _this$state2.hoverValue,
          firstSelectedValue = _this$state2.firstSelectedValue,
          value = _this$state2.value;
      var _this$props = _this.props,
          onKeyDown = _this$props.onKeyDown,
          disabledDate = _this$props.disabledDate; // Update last time of the picker

      var updateHoverPoint = function updateHoverPoint(func) {
        // Change hover to make focus in UI
        var currentHoverTime;
        var nextHoverTime;
        var nextHoverValue;

        if (!firstSelectedValue) {
          currentHoverTime = hoverValue[0] || selectedValue[0] || value[0] || moment();
          nextHoverTime = func(currentHoverTime);
          nextHoverValue = [nextHoverTime];

          _this.fireHoverValueChange(nextHoverValue);
        } else {
          if (hoverValue.length === 1) {
            currentHoverTime = hoverValue[0].clone();
            nextHoverTime = func(currentHoverTime);
            nextHoverValue = _this.onDayHover(nextHoverTime);
          } else {
            currentHoverTime = hoverValue[0].isSame(firstSelectedValue, 'day') ? hoverValue[1] : hoverValue[0];
            nextHoverTime = func(currentHoverTime);
            nextHoverValue = _this.onDayHover(nextHoverTime);
          }
        } // Find origin hover time on value index


        if (nextHoverValue.length >= 2) {
          var miss = nextHoverValue.some(function (ht) {
            return !includesTime(value, ht, 'month');
          });

          if (miss) {
            var newValue = nextHoverValue.slice().sort(function (t1, t2) {
              return t1.valueOf() - t2.valueOf();
            });

            if (newValue[0].isSame(newValue[1], 'month')) {
              newValue[1] = newValue[0].clone().add(1, 'month');
            }

            _this.fireValueChange(newValue);
          }
        } else if (nextHoverValue.length === 1) {
          // If only one value, let's keep the origin panel
          var oriValueIndex = value.findIndex(function (time) {
            return time.isSame(currentHoverTime, 'month');
          });
          if (oriValueIndex === -1) oriValueIndex = 0;

          if (value.every(function (time) {
            return !time.isSame(nextHoverTime, 'month');
          })) {
            var _newValue = value.slice();

            _newValue[oriValueIndex] = nextHoverTime.clone();

            _this.fireValueChange(_newValue);
          }
        }

        event.preventDefault();
        return nextHoverTime;
      };

      switch (keyCode) {
        case KeyCode.DOWN:
          updateHoverPoint(function (time) {
            return goTime(time, 1, 'weeks');
          });
          return;

        case KeyCode.UP:
          updateHoverPoint(function (time) {
            return goTime(time, -1, 'weeks');
          });
          return;

        case KeyCode.LEFT:
          if (ctrlKey) {
            updateHoverPoint(function (time) {
              return goTime(time, -1, 'years');
            });
          } else {
            updateHoverPoint(function (time) {
              return goTime(time, -1, 'days');
            });
          }

          return;

        case KeyCode.RIGHT:
          if (ctrlKey) {
            updateHoverPoint(function (time) {
              return goTime(time, 1, 'years');
            });
          } else {
            updateHoverPoint(function (time) {
              return goTime(time, 1, 'days');
            });
          }

          return;

        case KeyCode.HOME:
          updateHoverPoint(function (time) {
            return goStartMonth(time);
          });
          return;

        case KeyCode.END:
          updateHoverPoint(function (time) {
            return goEndMonth(time);
          });
          return;

        case KeyCode.PAGE_DOWN:
          updateHoverPoint(function (time) {
            return goTime(time, 1, 'month');
          });
          return;

        case KeyCode.PAGE_UP:
          updateHoverPoint(function (time) {
            return goTime(time, -1, 'month');
          });
          return;

        case KeyCode.ENTER:
          {
            var lastValue;

            if (hoverValue.length === 0) {
              lastValue = updateHoverPoint(function (time) {
                return time;
              });
            } else if (hoverValue.length === 1) {
              lastValue = hoverValue[0];
            } else {
              lastValue = hoverValue[0].isSame(firstSelectedValue, 'day') ? hoverValue[1] : hoverValue[0];
            }

            if (lastValue && (!disabledDate || !disabledDate(lastValue))) {
              _this.onSelect(lastValue);
            }

            event.preventDefault();
            return;
          }

        default:
          if (onKeyDown) {
            onKeyDown(event);
          }

      }
    });

    _defineProperty(_assertThisInitialized(_this), "onDayHover", function (value) {
      var hoverValue = [];
      var _this$state3 = _this.state,
          selectedValue = _this$state3.selectedValue,
          firstSelectedValue = _this$state3.firstSelectedValue;
      var type = _this.props.type;

      if (type === 'start' && selectedValue[1]) {
        hoverValue = _this.compare(value, selectedValue[1]) < 0 ? [value, selectedValue[1]] : [value];
      } else if (type === 'end' && selectedValue[0]) {
        hoverValue = _this.compare(value, selectedValue[0]) > 0 ? [selectedValue[0], value] : [];
      } else {
        if (!firstSelectedValue) {
          if (_this.state.hoverValue.length) {
            _this.setState({
              hoverValue: []
            });
          }

          return hoverValue;
        }

        hoverValue = _this.compare(value, firstSelectedValue) < 0 ? [value, firstSelectedValue] : [firstSelectedValue, value];
      }

      _this.fireHoverValueChange(hoverValue);

      return hoverValue;
    });

    _defineProperty(_assertThisInitialized(_this), "onToday", function () {
      var startValue = getTodayTime(_this.state.value[0]);
      var endValue = startValue.clone().add(1, 'months');

      _this.setState({
        value: [startValue, endValue]
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onOpenTimePicker", function () {
      _this.setState({
        showTimePicker: true
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onCloseTimePicker", function () {
      _this.setState({
        showTimePicker: false
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onOk", function () {
      var selectedValue = _this.state.selectedValue;

      if (_this.isAllowedDateAndTime(selectedValue)) {
        _this.props.onOk(_this.state.selectedValue);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onStartInputChange", function () {
      for (var _len = arguments.length, oargs = new Array(_len), _key = 0; _key < _len; _key++) {
        oargs[_key] = arguments[_key];
      }

      var args = ['left'].concat(oargs);
      return onInputSelect.apply(_assertThisInitialized(_this), args);
    });

    _defineProperty(_assertThisInitialized(_this), "onEndInputChange", function () {
      for (var _len2 = arguments.length, oargs = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        oargs[_key2] = arguments[_key2];
      }

      var args = ['right'].concat(oargs);
      return onInputSelect.apply(_assertThisInitialized(_this), args);
    });

    _defineProperty(_assertThisInitialized(_this), "onStartInputSelect", function (value) {
      var args = ['left', value, {
        source: 'dateInputSelect'
      }];
      return onInputSelect.apply(_assertThisInitialized(_this), args);
    });

    _defineProperty(_assertThisInitialized(_this), "onEndInputSelect", function (value) {
      var args = ['right', value, {
        source: 'dateInputSelect'
      }];
      return onInputSelect.apply(_assertThisInitialized(_this), args);
    });

    _defineProperty(_assertThisInitialized(_this), "onStartValueChange", function (leftValue) {
      var value = _toConsumableArray(_this.state.value);

      value[0] = leftValue;
      return _this.fireValueChange(value, 'left');
    });

    _defineProperty(_assertThisInitialized(_this), "onEndValueChange", function (rightValue) {
      var value = _toConsumableArray(_this.state.value);

      value[1] = rightValue;
      return _this.fireValueChange(value, 'right');
    });

    _defineProperty(_assertThisInitialized(_this), "onStartPanelChange", function (value, mode) {
      var _assertThisInitialize = _assertThisInitialized(_this),
          props = _assertThisInitialize.props,
          state = _assertThisInitialize.state;

      var newMode = [mode, state.mode[1]];

      if (!('mode' in props)) {
        _this.setState({
          mode: newMode
        });
      }

      var newValue = [value || state.value[0], state.value[1]];
      props.onPanelChange(newValue, newMode);
    });

    _defineProperty(_assertThisInitialized(_this), "onEndPanelChange", function (value, mode) {
      var _assertThisInitialize2 = _assertThisInitialized(_this),
          props = _assertThisInitialize2.props,
          state = _assertThisInitialize2.state;

      var newMode = [state.mode[0], mode];

      if (!('mode' in props)) {
        _this.setState({
          mode: newMode
        });
      }

      var newValue = [state.value[0], value || state.value[1]];
      props.onPanelChange(newValue, newMode);
    });

    _defineProperty(_assertThisInitialized(_this), "getStartValue", function () {
      var value = _this.state.value[0];
      var selectedValue = _this.state.selectedValue; // keep selectedTime when select date

      if (selectedValue[0] && _this.props.timePicker) {
        value = value.clone();
        syncTime(selectedValue[0], value);
      }

      if (_this.state.showTimePicker && selectedValue[0]) {
        return selectedValue[0];
      }

      return value;
    });

    _defineProperty(_assertThisInitialized(_this), "getEndValue", function () {
      var _this$state4 = _this.state,
          value = _this$state4.value,
          selectedValue = _this$state4.selectedValue,
          showTimePicker = _this$state4.showTimePicker;
      var endValue = value[1] ? value[1].clone() : value[0].clone().add(1, 'month'); // keep selectedTime when select date

      if (selectedValue[1] && _this.props.timePicker) {
        syncTime(selectedValue[1], endValue);
      }

      if (showTimePicker) {
        return selectedValue[1] ? selectedValue[1] : _this.getStartValue();
      }

      return endValue;
    });

    _defineProperty(_assertThisInitialized(_this), "getEndDisableTime", function () {
      var _this$state5 = _this.state,
          selectedValue = _this$state5.selectedValue,
          value = _this$state5.value;
      var disabledTime = _this.props.disabledTime;
      var userSettingDisabledTime = disabledTime(selectedValue, 'end') || {};
      var startValue = selectedValue && selectedValue[0] || value[0].clone(); // if startTime and endTime is same day..
      // the second time picker will not able to pick time before first time picker

      if (!selectedValue[1] || startValue.isSame(selectedValue[1], 'day')) {
        var hours = startValue.hour();
        var minutes = startValue.minute();
        var second = startValue.second();
        var _disabledHours = userSettingDisabledTime.disabledHours,
            _disabledMinutes = userSettingDisabledTime.disabledMinutes,
            _disabledSeconds = userSettingDisabledTime.disabledSeconds;
        var oldDisabledMinutes = _disabledMinutes ? _disabledMinutes() : [];
        var olddisabledSeconds = _disabledSeconds ? _disabledSeconds() : [];
        _disabledHours = generateOptions(hours, _disabledHours);
        _disabledMinutes = generateOptions(minutes, _disabledMinutes);
        _disabledSeconds = generateOptions(second, _disabledSeconds);
        return {
          disabledHours: function disabledHours() {
            return _disabledHours;
          },
          disabledMinutes: function disabledMinutes(hour) {
            if (hour === hours) {
              return _disabledMinutes;
            }

            return oldDisabledMinutes;
          },
          disabledSeconds: function disabledSeconds(hour, minute) {
            if (hour === hours && minute === minutes) {
              return _disabledSeconds;
            }

            return olddisabledSeconds;
          }
        };
      }

      return userSettingDisabledTime;
    });

    _defineProperty(_assertThisInitialized(_this), "isAllowedDateAndTime", function (selectedValue) {
      return isAllowedDate(selectedValue[0], _this.props.disabledDate, _this.disabledStartTime) && isAllowedDate(selectedValue[1], _this.props.disabledDate, _this.disabledEndTime);
    });

    _defineProperty(_assertThisInitialized(_this), "isMonthYearPanelShow", function (mode) {
      return ['month', 'year', 'decade'].indexOf(mode) > -1;
    });

    _defineProperty(_assertThisInitialized(_this), "hasSelectedValue", function () {
      var selectedValue = _this.state.selectedValue;
      return !!selectedValue[1] && !!selectedValue[0];
    });

    _defineProperty(_assertThisInitialized(_this), "compare", function (v1, v2) {
      if (_this.props.timePicker) {
        return v1.diff(v2);
      }

      return v1 && v1.diff(v2, 'days');
    });

    _defineProperty(_assertThisInitialized(_this), "fireSelectValueChange", function (selectedValue, direct, cause) {
      var timePicker = _this.props.timePicker;
      var prevSelectedValue = _this.state.prevSelectedValue;

      if (timePicker && timePicker.props.defaultValue) {
        var timePickerDefaultValue = timePicker.props.defaultValue;

        if (!prevSelectedValue[0] && selectedValue[0]) {
          syncTime(timePickerDefaultValue[0], selectedValue[0]);
        }

        if (!prevSelectedValue[1] && selectedValue[1]) {
          syncTime(timePickerDefaultValue[1], selectedValue[1]);
        }
      }

      if (!('selectedValue' in _this.props)) {
        _this.setState({
          selectedValue: selectedValue
        });
      } // 尚未选择过时间，直接输入的话


      if (!_this.state.selectedValue[0] || !_this.state.selectedValue[1]) {
        var startValue = selectedValue[0] || moment();
        var endValue = selectedValue[1] || startValue.clone().add(1, 'months');

        _this.setState({
          selectedValue: selectedValue,
          value: getValueFromSelectedValue([startValue, endValue])
        });
      }

      if (selectedValue[0] && !selectedValue[1]) {
        _this.setState({
          firstSelectedValue: selectedValue[0]
        });

        _this.fireHoverValueChange(selectedValue.concat());
      }

      selectedValue.map(function (item) {
        if (item) {
          item._type = 'range';
        }
      });

      _this.props.onChange(selectedValue);

      if (direct || selectedValue[0] && selectedValue[1]) {
        _this.setState({
          prevSelectedValue: selectedValue,
          firstSelectedValue: null
        });

        _this.fireHoverValueChange([]); // 第三个参数标识是否是从rangePicker传过去的


        _this.props.onSelect(selectedValue, cause, true);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "fireValueChange", function (value, direction) {
      var panelValues = _this.state.panelValues;
      var props = _this.props;

      if (!('value' in props)) {
        _this.setState({
          value: value,
          panelValues: direction === 'left' && panelValues ? [null, panelValues[1]] : direction === 'right' && panelValues ? [panelValues[0], null] : null
        });
      }

      props.onValueChange(value);
    });

    _defineProperty(_assertThisInitialized(_this), "fireHoverValueChange", function (hoverValue) {
      var props = _this.props;

      if (!('hoverValue' in props)) {
        _this.setState({
          hoverValue: hoverValue
        });
      }

      props.onHoverChange(hoverValue);
    });

    _defineProperty(_assertThisInitialized(_this), "clear", function () {
      _this.fireSelectValueChange([], true);

      _this.props.onClear([]);
    });

    _defineProperty(_assertThisInitialized(_this), "disabledStartTime", function (time) {
      return _this.props.disabledTime(time, 'start');
    });

    _defineProperty(_assertThisInitialized(_this), "disabledEndTime", function (time) {
      return _this.props.disabledTime(time, 'end');
    });

    _defineProperty(_assertThisInitialized(_this), "disabledStartMonth", function (month) {
      var value = _this.state.value;
      return month.isSameOrAfter(value[1], 'month');
    });

    _defineProperty(_assertThisInitialized(_this), "disabledEndMonth", function (month) {
      var value = _this.state.value;
      return month.isSameOrBefore(value[0], 'month');
    });

    _defineProperty(_assertThisInitialized(_this), "onMouseOver", function (e) {
      e.stopPropagation();
    });

    var _selectedValue2 = _props.selectedValue || _props.defaultSelectedValue || [];

    var _value = normalizeAnchor(_props, 1);

    _this.state = {
      selectedValue: _selectedValue2,
      prevSelectedValue: _selectedValue2,
      firstSelectedValue: null,
      hoverValue: _props.hoverValue || [],
      value: _value,
      showTimePicker: false,
      mode: _props.mode || ['date', 'date'],
      panelValues: _props.panelValues || null
    };
    return _this;
  }

  _createClass(RangeCalendar, [{
    key: "render",
    value: function render() {
      var _className, _classnames;

      var props = this.props,
          state = this.state;
      var prefixCls = props.prefixCls,
          dateInputPlaceholder = props.dateInputPlaceholder,
          seperator = props.seperator,
          timePicker = props.timePicker,
          showOk = props.showOk,
          locale = props.locale,
          showClear = props.showClear,
          showToday = props.showToday,
          type = props.type,
          clearIcon = props.clearIcon,
          onStartInputBlur = props.onStartInputBlur,
          onEndInputBlur = props.onEndInputBlur;
      var hoverValue = state.hoverValue,
          selectedValue = state.selectedValue,
          mode = state.mode,
          showTimePicker = state.showTimePicker,
          panelValues = state.panelValues;
      var className = (_className = {}, _defineProperty(_className, props.className, !!props.className), _defineProperty(_className, prefixCls, 1), _defineProperty(_className, "".concat(prefixCls, "-hidden"), !props.visible), _defineProperty(_className, "".concat(prefixCls, "-range"), 1), _defineProperty(_className, "".concat(prefixCls, "-show-time-picker"), showTimePicker), _defineProperty(_className, "".concat(prefixCls, "-week-number"), props.showWeekNumber), _className);
      var classes = classnames(className);
      var newProps = {
        originMode: props.originMode,
        // TODO: 通过picker简化配置
        selectedValue: state.selectedValue,
        onSelect: this.onSelect,
        onDayHover: type === 'start' && selectedValue[1] || type === 'end' && selectedValue[0] || !!hoverValue.length ? this.onDayHover : undefined,
        onMonthSelect: props.originMode.includes("month") ? this.onMonthSelect : null,
        onYearSelect: props.originMode.includes("year") ? this.onYearSelect : null
      };
      var placeholder1;
      var placeholder2;

      if (dateInputPlaceholder) {
        if (Array.isArray(dateInputPlaceholder)) {
          var _dateInputPlaceholder = _slicedToArray(dateInputPlaceholder, 2);

          placeholder1 = _dateInputPlaceholder[0];
          placeholder2 = _dateInputPlaceholder[1];
        } else {
          placeholder1 = placeholder2 = dateInputPlaceholder;
        }
      }

      var showOkButton = showOk === true || showOk !== false && !!timePicker;
      var cls = classnames((_classnames = {}, _defineProperty(_classnames, "".concat(prefixCls, "-footer"), true), _defineProperty(_classnames, "".concat(prefixCls, "-range-bottom"), true), _defineProperty(_classnames, "".concat(prefixCls, "-footer-show-ok"), showOkButton), _classnames));
      var startValue = this.getStartValue();
      var endValue = this.getEndValue();
      var todayTime = getTodayTime(startValue);
      var thisMonth = todayTime.month();
      var thisYear = todayTime.year();
      var isTodayInView = startValue.year() === thisYear && startValue.month() === thisMonth || endValue.year() === thisYear && endValue.month() === thisMonth;
      var nextMonthOfStart = startValue.clone().add(1, 'months');
      var isClosestMonths = nextMonthOfStart.year() === endValue.year() && nextMonthOfStart.month() === endValue.month();
      var extraFooter = props.renderFooter();
      var leftPanelValue = panelValues && panelValues[0] ? {
        panelValue: moment(panelValues[0])
      } : {};
      var rightPanelValue = panelValues && panelValues[1] ? {
        panelValue: moment(panelValues[1])
      } : {};
      return /*#__PURE__*/React.createElement("div", {
        ref: this.saveRoot,
        className: classes,
        style: props.style,
        onKeyDown: this.onKeyDown
      }, props.renderSidebar(), /*#__PURE__*/React.createElement("div", {
        className: "".concat(prefixCls, "-panel"),
        onMouseOver: this.onMouseOver
      }, showClear && selectedValue[0] && selectedValue[1] ? /*#__PURE__*/React.createElement("a", {
        role: "button",
        title: locale.clear,
        onClick: this.clear
      }, clearIcon || /*#__PURE__*/React.createElement("span", {
        className: "".concat(prefixCls, "-clear-btn uf uf-close-c")
      })) : null, /*#__PURE__*/React.createElement("div", {
        className: "".concat(prefixCls, "-date-panel"),
        onMouseLeave: type !== 'both' ? this.onDatePanelLeave : undefined,
        onMouseEnter: type !== 'both' ? this.onDatePanelEnter : undefined
      }, /*#__PURE__*/React.createElement(CalendarPart, _extends({}, props, newProps, {
        hoverValue: hoverValue,
        direction: "left",
        disabledTime: this.disabledStartTime,
        disabledMonth: this.disabledStartMonth,
        format: this.getFormat(),
        value: startValue,
        mode: mode[0],
        placeholder: placeholder1,
        onInputChange: this.onStartInputChange,
        onInputSelect: this.onStartInputSelect,
        onValueChange: this.onStartValueChange,
        onPanelChange: this.onStartPanelChange,
        showDateInput: this.props.showDateInput,
        timePicker: timePicker,
        showTimePicker: showTimePicker,
        enablePrev: true,
        enableNext: !isClosestMonths || this.isMonthYearPanelShow(mode[1]),
        clearIcon: clearIcon,
        tabIndex: "0",
        onInputBlur: onStartInputBlur
      }, leftPanelValue)), /*#__PURE__*/React.createElement("span", {
        className: "".concat(prefixCls, "-range-middle")
      }, seperator), /*#__PURE__*/React.createElement(CalendarPart, _extends({}, props, newProps, {
        hoverValue: hoverValue,
        direction: "right",
        format: this.getFormat(),
        timePickerDisabledTime: this.getEndDisableTime(),
        placeholder: placeholder2,
        value: endValue,
        mode: mode[1],
        onInputChange: this.onEndInputChange,
        onInputSelect: this.onEndInputSelect,
        onValueChange: this.onEndValueChange,
        onPanelChange: this.onEndPanelChange,
        showDateInput: this.props.showDateInput,
        timePicker: timePicker,
        showTimePicker: showTimePicker,
        disabledTime: this.disabledEndTime,
        disabledMonth: this.disabledEndMonth,
        enablePrev: !isClosestMonths || this.isMonthYearPanelShow(mode[0]),
        enableNext: true,
        clearIcon: clearIcon,
        tabIndex: "0",
        inputTabIndex: "-1",
        onInputBlur: onEndInputBlur
      }, rightPanelValue, {
        noCurrentDate: true
      }))), /*#__PURE__*/React.createElement("div", {
        className: cls
      }, showToday || props.timePicker || showOkButton || extraFooter ? /*#__PURE__*/React.createElement("div", {
        className: "".concat(prefixCls, "-footer-btn")
      }, extraFooter ? /*#__PURE__*/React.createElement("div", {
        className: "".concat(prefixCls, "-footer-extra")
      }, extraFooter) : null, showToday ? /*#__PURE__*/React.createElement(TodayButton, _extends({}, props, {
        disabled: isTodayInView,
        value: state.value[0],
        onToday: this.onToday,
        text: locale.backToToday
      })) : null, props.timePicker ? /*#__PURE__*/React.createElement(TimePickerButton, _extends({}, props, {
        showTimePicker: showTimePicker,
        onOpenTimePicker: this.onOpenTimePicker,
        onCloseTimePicker: this.onCloseTimePicker,
        timePickerDisabled: !this.hasSelectedValue() || hoverValue.length
      })) : null, showOkButton ? /*#__PURE__*/React.createElement(OkButton, _extends({}, props, {
        onOk: this.onOk,
        okDisabled: !this.isAllowedDateAndTime(selectedValue) || !this.hasSelectedValue() || hoverValue.length || !(startValue && endValue) // okDisabled = {false}

      })) : null) : null)));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, state) {
      var newState = {};

      if ('value' in nextProps) {
        newState.value = normalizeAnchor(nextProps, 0);
      }

      if ('hoverValue' in nextProps && !isArraysEqual(state.hoverValue, nextProps.hoverValue)) {
        newState.hoverValue = nextProps.hoverValue;
      }

      if ('selectedValue' in nextProps) {
        newState.selectedValue = nextProps.selectedValue;
        newState.prevSelectedValue = nextProps.selectedValue;
      }

      if ('mode' in nextProps && !isArraysEqual(state.mode, nextProps.mode)) {
        newState = {
          mode: nextProps.mode
        };
      }

      return newState;
    }
  }]);

  return RangeCalendar;
}(React.Component);

_defineProperty(RangeCalendar, "propTypes", _objectSpread(_objectSpread({}, propType), {}, {
  prefixCls: PropTypes.string,
  dateInputPlaceholder: PropTypes.any,
  seperator: PropTypes.string,
  defaultValue: PropTypes.any,
  value: PropTypes.any,
  hoverValue: PropTypes.any,
  mode: PropTypes.arrayOf(PropTypes.oneOf(['date', 'month', 'year', 'decade'])),
  showDateInput: PropTypes.bool,
  timePicker: PropTypes.any,
  showOk: PropTypes.bool,
  showToday: PropTypes.bool,
  defaultSelectedValue: PropTypes.array,
  selectedValue: PropTypes.array,
  onOk: PropTypes.func,
  showClear: PropTypes.bool,
  locale: PropTypes.object,
  onChange: PropTypes.func,
  onSelect: PropTypes.func,
  onValueChange: PropTypes.func,
  onHoverChange: PropTypes.func,
  onPanelChange: PropTypes.func,
  format: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  onClear: PropTypes.func,
  type: PropTypes.any,
  disabledDate: PropTypes.func,
  disabledTime: PropTypes.func,
  clearIcon: PropTypes.node,
  onKeyDown: PropTypes.func
}));

_defineProperty(RangeCalendar, "defaultProps", _objectSpread(_objectSpread({}, defaultProp), {}, {
  type: 'both',
  seperator: '~',
  defaultSelectedValue: [],
  onValueChange: noop,
  onHoverChange: noop,
  onPanelChange: noop,
  disabledTime: noop,
  onInputSelect: noop,
  showToday: true,
  showDateInput: true
}));

polyfill(RangeCalendar);
export default commonMixinWrapper(RangeCalendar);


// WEBPACK FOOTER //
// ./~/@tinper/next-ui/lib/wui-datepicker/src/rc-calendar/RangeCalendar.js